import { MessageDescriptor } from '@formatjs/intl';
import {
  LOCATIONS,
  locationMessages,
  CATEGORIES,
  categoryMessages,
  SORT_OPTIONS,
} from '../constants';
import { Filter } from '../api/getFirestoreItemByQuery.ts';
import { WhereFilterOp } from 'firebase/firestore';
import { firebaseConfig } from '../api/firebaseConfig.ts';

type TFormatMessage = (
  descriptor: MessageDescriptor,
  values?: Record<string, string | number>,
) => string;

export const getTranslatedLocations = (formatMessage: TFormatMessage) =>
  LOCATIONS.map((location) => ({
    ...location,
    name: formatMessage(
      locationMessages[
        `location${location.id}` as keyof typeof locationMessages
      ],
    ),
  })).sort((a, b) => a.name.localeCompare(b.name));

export const getTranslatedCategories = (formatMessage: TFormatMessage) =>
  CATEGORIES.map((category) => ({
    ...category,
    name: formatMessage(
      categoryMessages[
        `category${category.id}` as keyof typeof categoryMessages
      ],
    ),
  })).sort((a, b) => a.name.localeCompare(b.name));

export const getQueryFilter = ({
  field,
  operator = '==',
  value,
}: {
  field: string;
  operator?: WhereFilterOp;
  value: string | number;
}): Filter => ({
  field,
  operator,
  value,
});

export function formatISODate(isoDate: string) {
  if (!isoDate) return '';

  return isoDate.slice(0, 16).replace('T', ' ');
}

export const getSendContactEmailUrl = (env: string) =>
  `https://us-central1-${firebaseConfig[env]?.projectId}.cloudfunctions.net/sendContactEmail`;

export const getSendInternalNotificationUrl = (env: string) =>
  `https://us-central1-${firebaseConfig[env]?.projectId}.cloudfunctions.net/sendInternalNotification`;

export const getFormattedLocations = (formatMessage: TFormatMessage) =>
  getTranslatedLocations(formatMessage).map((location) => ({
    value: location.id,
    label: location.name,
  }));

export const getFormattedCategories = (formatMessage: TFormatMessage) =>
  getTranslatedCategories(formatMessage).map((category) => ({
    value: category.id,
    label: category.name,
  }));

export const getFormattedSortOptions = (formatMessage: TFormatMessage) =>
  Object.entries(SORT_OPTIONS).map(([key, option]) => ({
    value: key,
    label: formatMessage(option),
  }));
